
function fitReleaseDate(el) {
  const maxWidth = el.offsetWidth;
  if (!maxWidth) return;

  let fontSize = parseFloat(window.getComputedStyle(el).fontSize);

  el.style.fontSize = fontSize + "px";

  while (el.scrollWidth > maxWidth && fontSize > 10) {
    fontSize -= 0.5;
    el.style.fontSize = fontSize + "px";
  }
}

function ordinal(n) {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

function initReleaseDates() {

  const elements = document.querySelectorAll(".release-date");

  elements.forEach(function (el) {

    const releaseDateStr = el.getAttribute("data-release");
    if (!releaseDateStr) return;

    const releaseDate = new Date(releaseDateStr + "T00:00:00");
    const now = new Date();

    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const startOfRelease = new Date(releaseDate.getFullYear(), releaseDate.getMonth(), releaseDate.getDate());

    const diffTime = startOfRelease - startOfToday;
    const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

    const twoWeeksAfter = new Date(releaseDate);
    twoWeeksAfter.setDate(twoWeeksAfter.getDate() + 14);

    const day = releaseDate.getDate();
    const month = releaseDate.toLocaleString("en-US", { month: "long" });

    let output = "";

    if (now < releaseDate) {

      if (diffDays <= 1) {
        output = "RELEASES TOMORROW";

      } else if (diffDays <= 5) {
        output = "RELEASES IN " + diffDays + " DAYS";

      } else {
        output = "RELEASES " + ordinal(day) + " " + month;
      }

    } else if (now >= releaseDate && now <= twoWeeksAfter) {
      el.classList.add("out-now");
      output = "OUT NOW";

    } else {
      el.style.display = "none";
      return;
    }

    el.textContent = output.toUpperCase();

    // ONLY floating badges get auto-fit (collection/homepage)
    if (el.classList.contains("floating")) {
      fitReleaseDate(el);
    }

  });

}

// run safely across Shopify templates
document.addEventListener("DOMContentLoaded", initReleaseDates);
window.addEventListener("load", initReleaseDates);
document.addEventListener("shopify:section:load", initReleaseDates);